<template>
  <v-list-item>
    <v-list-item-content>
      <span>
        {{ saldo.saldo }} UN
      </span>
      <span class="caption">
        <px-entrega-produto-saldo-situacao :situacao="saldo.situacaoEntrega"/>
      </span>
      <span v-if="saldo.observacaoInterna">
          <px-show-large-text :large-text="saldo.observacaoInterna"/>
      </span>
    </v-list-item-content>
    <v-list-item-content>
      {{ saldo.dataPrevisaoFaturamento | date }}
      <div class="caption">
        Previsão de faturamento
      </div>
    </v-list-item-content>
    <v-list-item-content v-if="isFaturadoOuEntregue">
      <template v-if="saldo.dataFaturamento">
        {{ saldo.dataFaturamento | date }}
        <div class="caption">
          Data de faturamento
        </div>
      </template>
    </v-list-item-content>
    <v-list-item-content>
      {{ saldo.dataPrevisaoEntrega | date }}
      <div class="caption">
        Previsão de entrega
      </div>
    </v-list-item-content>
    <v-list-item-content>
      <template v-if="saldo.dataEntrega && isEntregue">
        {{ saldo.dataEntrega | date }}
        <div class="caption">
          Data de entrega
        </div>
      </template>
    </v-list-item-content>
  </v-list-item>
</template>

<script>

import { SituacaoGestaoEntregaProdutoSaldo } from 'px-business-components';

export default {
  props: {
    compraProduto: Object,
    saldo: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loadingOperation: false,
    };
  },
  computed: {
    isEntregue() {
      return this.saldo.situacaoEntrega === SituacaoGestaoEntregaProdutoSaldo.keys.ENTREGUE.key;
    },
    isPendente() {
      return this.saldo.situacaoEntrega === SituacaoGestaoEntregaProdutoSaldo.keys.PENDENTE.key;
    },
    isFaturado() {
      return this.saldo.situacaoEntrega === SituacaoGestaoEntregaProdutoSaldo.keys.FATURADO.key;
    },
    isFaturadoOuEntregue() {
      return this.isFaturado || this.isEntregue;
    },
    rollbackDescription() {
      if (this.isEntregue) {
        return 'Voltar para pendente';
      }
      return '';
    },
  },
};
</script>
